import { render, staticRenderFns } from "./ItemsForShippingModal.vue?vue&type=template&id=29bd00cb&"
import script from "./ItemsForShippingModal.vue?vue&type=script&lang=js&"
export * from "./ItemsForShippingModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemsForShippingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports